import {messageResendZajavls, messageResendZajavlsEn} from '@language/messages';
import {getRequest} from '@requests';
import {LOADING_APPLICATION, NOTIFICATIONS_APPLICATION, OPEN_WRONG_PAGE} from '../store/actionTypes';
import LanguageService from "@services/language/LanguageService";

export function loadingApplication(status) {
    return (dispatch) => {
        dispatch({
            type: LOADING_APPLICATION,
            status,
        });
    };
}
export function addNotification(notification) {
    return (dispatch, getState) => {
        const {notificationsApplication} = getState();
        const key = notificationsApplication.nextNotification + 1;
        notification.key = key;
        dispatch({
            type: NOTIFICATIONS_APPLICATION,
            object: {nextNotification: key, notifications: [...notificationsApplication.notifications, notification]},
        });
    };
}
export function removeNotification(removeKey) {
    return (dispatch, getState) => {
        const {notificationsApplication} = getState();
        const notificationsApplicationFiltered = notificationsApplication.notifications.filter((notification) => {
            return notification.key !== removeKey;
        });
        dispatch({
            type: NOTIFICATIONS_APPLICATION,
            object: {
                nextNotification: notificationsApplication.nextNotification,
                notifications: notificationsApplicationFiltered,
            },
        });
    };
}

export const openWrongPage = () => {
    return {
        type: OPEN_WRONG_PAGE,
        payload: true,
    };
};

export function resendZajavlsIfExistsNotification() {
    return async (dispatch, getState) => {
        try {
            const {apiDomainVikon} = getState();
            const result = await getRequest(`${apiDomainVikon}api/digital_profile/applicant/zajavls/is_has_zajavls_into_actual_campaign`);
            const lang = LanguageService.getLang() || 'ru';
            if (typeof result.errors === 'undefined' && result.is_has_zajavls === true) {
                dispatch(addNotification({
                    message: lang === 'ru' ? messageResendZajavls : messageResendZajavlsEn,
                    type: 'info'
                }));
            }
        } catch (e) {
            dispatch(addNotification({message: e.message, type: 'error'}));
        }
    };
}
